import { styled } from '@mui/material'

const ControlsButton = styled('button')({
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  color: 'white',
  border: 'none',
  padding: 0,
  margin: 10,
  height: 48,
  width: 48,
  lineHeight: '48px',
  fontWeight: 600,
  fontSize: '2rem',
  borderRadius: '50%',
  overflow: 'hidden',
  pointerEvents: 'auto',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },
})

export default ControlsButton
